/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  $('.js-tab__label').on('click', function() {
    $(this).toggleClass('js-tab__label--active');
    return $(this).parents('.js-tab').find('.js-tab__content').toggleClass('js-tab__content--active');
  });

  $('body').on('keyup', function(e) {
    if (e.which === 9) {
      $('body').addClass('tabbycat');
    }
  });
  
  $('body').on('click', function(e) {
    $('body').removeClass('tabbycat');
  });
});
